export var AgentType;
(function (AgentType) {
    AgentType["catalog"] = "Prompts::CatalogAgent";
    AgentType["classification"] = "Prompts::ClassificationAgent";
    AgentType["conversation"] = "Prompts::ConversationAgent";
    AgentType["guard"] = "Prompts::GuardAgent";
    AgentType["intent"] = "Prompts::IntentAgent";
    AgentType["orchestrator"] = "Prompts::OrchestratorAgent";
    AgentType["order"] = "Prompts::OrderAgent";
    AgentType["product"] = "Prompts::ProductAgent";
    AgentType["product_inquiry"] = "Prompts::ProductInquiryAgent";
    AgentType["sentiment"] = "Prompts::SentimentAgent";
    AgentType["supervisor"] = "Prompts::SupervisorAgent";
})(AgentType || (AgentType = {}));
